// import React, { useEffect, useState } from 'react';
// import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// import { auth, database, ref, onValue } from './firebase';
// import globalSyncService from './Services/GlobalSyncService';
// import LoginPage from './Components/LoginPage';
// import Dashboard, { menuData } from './Components/Dashboard';
// import ProductTable from './Components/ProductTable';
// import CategoryTable from './Components/CategoryTable';
// import GroupTable from './Components/GroupTable';
// import BrandTable from './Components/BrandTable';
// import UnitTable from './Components/UnitTable';
// import AddTax from './Components/AddTax';
// import Payments from './Components/Payments';
// import Payables from './Components/Payables';
// import Suppliers from './Components/Suppliers';
// import Customers from './Components/Customers';
// import Partners from './Components/Partners';
// import Stocks from './Components/Stocks';
// import SalesTable from './Components/SalesTable';
// import PurchaseReturnReportGenerator from './Components/PurchaseReturnReport';
// import PurchaseReportGenerator from './Components/PurchaseReportGenerator';
// import SalesReport from './Components/SalesReport';
// import StockReportGenerator from './Components/StockReportGenerator';
// import SalesReturnTable from './Components/SalesReturnTable';
// import Receivables from './Components/Receivables';
// import PurchaseBillTable from './Components/PurchaseBillTable';
// import ReturnBillsTable from './Components/ReturnBillTable';
// import BarcodeGenerator from './Components/Barcode';
// import Profile from './Components/Profile';
// import HoldBill from './Components/HoldBill';
// import GoDownStock from './Components/GoDownStock';
// import StoreStock from './Components/StoreStock';
// import StockSummary from './Components/StockSummary';
// import ProductProfitReportGenerator from './Components/ProductProfitReportGenerator';
// import SupplierPaymentEntryReportGenerator from './Components/SupplierPaymentEntryReportGenerator';
// import CustomerWiseReport from './Components/CustomerWiseReportGenerator';
// import CustomersOutstandingReportGenerator from './Components/CustomersOutstandingReportGenerator';
// import PurchaseOutstandingReportGenerator from './Components/PurchaseOutstandingReportGenerator';
// import ExpiryProductReportGenerator from './Components/ExpiryProductReportGenerator';
// import BarcodeListReportGenerator from './Components/BarcodeListReportGenerator';
// import TopSaling from './Components/TopSaling';
// import NonSaling from './Components/NonSaling';
// import BestSaling from './Components/BestSaling';
// import FestivalAI from './Components/FestivalAI';
// import TimelineAI from './Components/TimelineAI';
// import PurchaseSupplierGST from './Components/PurchaseSupplierWiseGST';
// import PurchaseProductWiseGST from './Components/PurchaseProductWiseGST';
// import PurchaseSupplierReturnGST from './Components/PurchaseSupplierReturnGST';
// import PurchaseProductReturnGST from './Components/PurchaseProductReturnGST';
// import SalesCustomerGST from './Components/SalesCustomerGST';
// import SalesProductGST from './Components/SalesProductGST';
// import SalesCustomerReturnGST from './Components/SalesCustomerReturnGST';
// import SalesProductReturnGST from './Components/SalesProductReturnGST';
// import SalesReturnReport from './Components/SalesReturnReport';
// import AddEmployeeRole from './Components/AddEmployeeRole';
// import ManageEmployeeRole from './Components/ManageEmployeeRole';
// import EmployeeRight from './Components/EmployeeRight';
// import EmployeeRights from './Components/EmployeeRights';

// const SUPER_ADMIN_EMAIL = 'saalim@gmail.com';

// const PlaceholderComponent = ({ title }) => (
//   <div>
//     <h2>{title}</h2>
//     <p>This feature is under development.</p>
//   </div>
// );

// const ProtectedRoute = ({ element, path, allowedMenus, isSuperAdmin, isBranch }) => {
//   // Superadmin or branch users have full access
//   if (isSuperAdmin || isBranch) return element;

//   const findMenuItem = (items, targetPath, parentLabel = '') => {
//     for (const item of items) {
//       if (item.path === targetPath) return { mainMenu: parentLabel || item.label, path: item.path };
//       if (item.submenu) {
//         const found = findMenuItem(item.submenu, targetPath, parentLabel || item.label);
//         if (found) return found;
//       }
//       if (item.subItems) {
//         const found = findMenuItem(item.subItems, targetPath, parentLabel || item.label);
//         if (found) return found;
//       }
//     }
//     return null;
//   };

//   const menuItem = findMenuItem(menuData, path);
//   const isAllowed = menuItem ? allowedMenus[menuItem.mainMenu]?.includes(menuItem.path) : true;

//   return isAllowed || path === '/dashboard' ? element : <Navigate to="/dashboard" replace />;
// };

// function App() {
//   const [allowedMenus, setAllowedMenus] = useState({});
//   const [isSuperAdmin, setIsSuperAdmin] = useState(false);
//   const [isBranch, setIsBranch] = useState(false);

//   useEffect(() => {
//     const unsubscribe = auth.onAuthStateChanged((user) => {
//       if (user) {
//         setIsSuperAdmin(user.email === SUPER_ADMIN_EMAIL);
//         const emailKey = user.email.replace(/\./g, '_');
//         const profileRef = ref(database, `users/${emailKey}/profile`);
//         onValue(profileRef, (snapshot) => {
//           const profileData = snapshot.val();
//           setIsBranch(profileData?.isBranch || false);
//           if (user.email !== SUPER_ADMIN_EMAIL && !profileData?.isBranch) {
//             const rightsRef = ref(database, `employeeRights/${emailKey}`);
//             onValue(rightsRef, (snapshot) => {
//               const data = snapshot.val();
//               setAllowedMenus(data?.allowedMenus || {});
//             });
//           } else {
//             setAllowedMenus({});
//           }
//         }, { onlyOnce: true });
//       } else {
//         setIsSuperAdmin(false);
//         setIsBranch(false);
//         setAllowedMenus({});
//       }
//     });
//     return () => unsubscribe();
//   }, []);

//   useEffect(() => {
//     console.log('🚀 App loaded - ensuring global sync is active...');
//     const syncChecker = setInterval(() => {
//       globalSyncService.ensureSyncActive();
//     }, 30000);
//     return () => clearInterval(syncChecker);
//   }, []);

//   useEffect(() => {
//     const handleVisibilityChange = () => {
//       if (!document.hidden && globalSyncService.currentUser) {
//         console.log('🔄 Tab became visible - ensuring sync is active...');
//         setTimeout(() => {
//           globalSyncService.ensureSyncActive();
//         }, 1000);
//       }
//     };
//     document.addEventListener('visibilitychange', handleVisibilityChange);
//     return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
//   }, []);

//   return (
//     <Router>
//       <div className="App">
//         <Routes>
//           <Route path="/login" element={<LoginPage />} />
//           <Route path="/dashboard" element={<Dashboard />}>
//             <Route
//               path="product"
//               element={<ProtectedRoute element={<ProductTable />} path="/dashboard/product" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="group-table"
//               element={<ProtectedRoute element={<GroupTable />} path="/dashboard/group-table" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="category-table"
//               element={<ProtectedRoute element={<CategoryTable />} path="/dashboard/category-table" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="brand-table"
//               element={<ProtectedRoute element={<BrandTable />} path="/dashboard/brand-table" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="unit-table"
//               element={<ProtectedRoute element={<UnitTable />} path="/dashboard/unit-table" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="tax"
//               element={<ProtectedRoute element={<PlaceholderComponent title="Tax" />} path="/dashboard/tax" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="gst-tax"
//               element={<ProtectedRoute element={<AddTax />} path="/dashboard/gst-tax" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="payment-modes"
//               element={<ProtectedRoute element={<Payments />} path="/dashboard/payment-modes" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="payables"
//               element={<ProtectedRoute element={<Payables />} path="/dashboard/payables" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="receivables"
//               element={<ProtectedRoute element={<Receivables />} path="/dashboard/receivables" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="suppliers"
//               element={<ProtectedRoute element={<Suppliers />} path="/dashboard/suppliers" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="customers"
//               element={<ProtectedRoute element={<Customers />} path="/dashboard/customers" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="partners"
//               element={<ProtectedRoute element={<Partners />} path="/dashboard/partners" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="purchase-invoice"
//               element={<ProtectedRoute element={<PurchaseBillTable />} path="/dashboard/purchase-invoice" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="purchase-return"
//               element={<ProtectedRoute element={<ReturnBillsTable />} path="/dashboard/purchase-return" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="barcode-generator"
//               element={<ProtectedRoute element={<BarcodeGenerator />} path="/dashboard/barcode-generator" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="salesform"
//               element={<ProtectedRoute element={<SalesTable />} path="/dashboard/salesform" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="salesReturn"
//               element={<ProtectedRoute element={<SalesReturnTable />} path="/dashboard/salesReturn" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="purchase-report"
//               element={<ProtectedRoute element={<PurchaseReportGenerator />} path="/dashboard/purchase-report" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="purchase-return-report"
//               element={<ProtectedRoute element={<PurchaseReturnReportGenerator />} path="/dashboard/purchase-return-report" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="sales-report"
//               element={<ProtectedRoute element={<SalesReport />} path="/dashboard/sales-report" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="sales-return-report"
//               element={<ProtectedRoute element={<SalesReturnReport />} path="/dashboard/sales-return-report" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="product-profit-report"
//               element={<ProtectedRoute element={<ProductProfitReportGenerator />} path="/dashboard/product-profit-report" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route path="accounts-report">
//               <Route
//                 path="supplier-payment"
//                 element={<ProtectedRoute element={<SupplierPaymentEntryReportGenerator />} path="/dashboard/accounts-report/supplier-payment" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//               />
//               <Route
//                 path="customer-receipt"
//                 element={<ProtectedRoute element={<CustomerWiseReport />} path="/dashboard/accounts-report/customer-receipt" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//               />
//               <Route
//                 path="customer-outstanding"
//                 element={<ProtectedRoute element={<CustomersOutstandingReportGenerator />} path="/dashboard/accounts-report/customer-outstanding" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//               />
//               <Route
//                 path="purchase-outstanding"
//                 element={<ProtectedRoute element={<PurchaseOutstandingReportGenerator />} path="/dashboard/accounts-report/purchase-outstanding" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//               />
//             </Route>
//             <Route
//               path="product-list-report"
//               element={<ProtectedRoute element={<BarcodeListReportGenerator />} path="/dashboard/product-list-report" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route path="sales-revenue-report">
//               <Route
//                 path="top-selling"
//                 element={<ProtectedRoute element={<TopSaling />} path="/dashboard/sales-revenue-report/top-selling" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//               />
//               <Route
//                 path="non-selling"
//                 element={<ProtectedRoute element={<NonSaling />} path="/dashboard/sales-revenue-report/non-selling" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//               />
//             </Route>
//             <Route
//               path="best-rate-finder"
//               element={<ProtectedRoute element={<BestSaling />} path="/dashboard/best-rate-finder" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="purchase-annexure-1a"
//               element={<ProtectedRoute element={<PlaceholderComponent title="Purchase Annexure 1A" />} path="/dashboard/purchase-annexure-1a" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="purchase-annexure-1a/supplierwise"
//               element={<ProtectedRoute element={<PurchaseSupplierGST />} path="/dashboard/purchase-annexure-1a/supplierwise" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="purchase-annexure-1a/productwise"
//               element={<ProtectedRoute element={<PurchaseProductWiseGST />} path="/dashboard/purchase-annexure-1a/productwise" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="purchase-return-annexure-2a"
//               element={<ProtectedRoute element={<PlaceholderComponent title="Purchase Return Annexure 2A" />} path="/dashboard/purchase-return-annexure-2a" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="purchase-return-annexure-2a/supplierwiseReturn"
//               element={<ProtectedRoute element={<PurchaseSupplierReturnGST />} path="/dashboard/purchase-return-annexure-2a/supplierwiseReturn" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="purchase-return-annexure-2a/productwiseReturn"
//               element={<ProtectedRoute element={<PurchaseProductReturnGST />} path="/dashboard/purchase-return-annexure-2a/productwiseReturn" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="sales-annexure-1a"
//               element={<ProtectedRoute element={<PlaceholderComponent title="Sales Annexure 1A" />} path="/dashboard/sales-annexure-1a" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="sales-annexure-1a/customerwise"
//               element={<ProtectedRoute element={<SalesCustomerGST />} path="/dashboard/sales-annexure-1a/customerwise" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="sales-annexure-1a/productwise"
//               element={<ProtectedRoute element={<SalesProductGST />} path="/dashboard/sales-annexure-1a/productwise" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="sales-return-annexure-2a"
//               element={<ProtectedRoute element={<PlaceholderComponent title="Sales Return Annexure 2A" />} path="/dashboard/sales-return-annexure-2a" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="sales-return-annexure-2a/customerwiseReturn"
//               element={<ProtectedRoute element={<SalesCustomerReturnGST />} path="/dashboard/sales-return-annexure-2a/customerwiseReturn" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="sales-return-annexure-2a/productwiseReturn"
//               element={<ProtectedRoute element={<SalesProductReturnGST />} path="/dashboard/sales-return-annexure-2a/productwiseReturn" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="location"
//               element={<ProtectedRoute element={<PlaceholderComponent title="Location" />} path="/dashboard/location" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="settings"
//               element={<ProtectedRoute element={<PlaceholderComponent title="Settings" />} path="/dashboard/settings" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="menus"
//               element={<ProtectedRoute element={<PlaceholderComponent title="Menus" />} path="/dashboard/menus" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route path="rolesRights">
//               <Route
//                 index
//                 element={<ProtectedRoute element={<PlaceholderComponent title="Roles & Rights" />} path="/dashboard/rolesRights" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//               />
//               <Route
//                 path="employeerole"
//                 element={<ProtectedRoute element={<AddEmployeeRole />} path="/dashboard/rolesRights/employeerole" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//               />
//               <Route
//                 path="manage-employee"
//                 element={<ProtectedRoute element={<ManageEmployeeRole />} path="/dashboard/rolesRights/manage-employee" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//               />
//               <Route
//                 path="employee"
//                 element={<ProtectedRoute element={<EmployeeRights />} path="/dashboard/rolesRights/employee" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//               />
//               <Route
//                 path="employeeright"
//                 element={<ProtectedRoute element={<EmployeeRight />} path="/dashboard/rolesRights/employeeright" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//               />
//             </Route>
//             <Route
//               path="general"
//               element={<ProtectedRoute element={<PlaceholderComponent title="General" />} path="/dashboard/general" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="doc-settings"
//               element={<ProtectedRoute element={<PlaceholderComponent title="Doc Settings" />} path="/dashboard/doc-settings" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="branch-profile"
//               element={<ProtectedRoute element={<Profile />} path="/dashboard/branch-profile" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="stock-report"
//               element={<ProtectedRoute element={<StockReportGenerator />} path="/dashboard/stock-report" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="stock-report/godown"
//               element={<ProtectedRoute element={<GoDownStock />} path="/dashboard/stock-report/godown" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="stock-report/store"
//               element={<ProtectedRoute element={<StoreStock />} path="/dashboard/stock-report/store" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="stock-report/summary"
//               element={<ProtectedRoute element={<StockSummary />} path="/dashboard/stock-report/summary" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="expiry-report"
//               element={<ProtectedRoute element={<ExpiryProductReportGenerator />} path="/dashboard/expiry-report" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="ai-reports/festival"
//               element={<ProtectedRoute element={<FestivalAI />} path="/dashboard/ai-reports/festival" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//             <Route
//               path="ai-reports/timeline"
//               element={<ProtectedRoute element={<TimelineAI />} path="/dashboard/ai-reports/timeline" allowedMenus={allowedMenus} isSuperAdmin={isSuperAdmin} isBranch={isBranch} />}
//             />
//           </Route>
//           <Route path="/hold-bill" element={<HoldBill />} />
//           <Route path="/" element={<Navigate to="/login" replace />} />
//         </Routes>
//       </div>
//     </Router>
//   );
// }

// export default App;

// import React, { useEffect, useState } from 'react';
// import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// import { auth, database, ref, onValue } from './firebase';
// import globalSyncService from './Services/GlobalSyncService';
// import LoginPage from './Components/LoginPage';
// import Dashboard from './Components/Dashboard';
// import ProductTable from './Components/ProductTable';
// import CategoryTable from './Components/CategoryTable';
// import GroupTable from './Components/GroupTable';
// import BrandTable from './Components/BrandTable';
// import UnitTable from './Components/UnitTable';
// import AddTax from './Components/AddTax';
// import Payments from './Components/Payments';
// import Payables from './Components/Payables';
// import Suppliers from './Components/Suppliers';
// import Customers from './Components/Customers';
// import Partners from './Components/Partners';
// import Stocks from './Components/Stocks';
// import SalesTable from './Components/SalesTable';
// import PurchaseReturnReportGenerator from './Components/PurchaseReturnReport';
// import PurchaseReportGenerator from './Components/PurchaseReportGenerator';
// import SalesReport from './Components/SalesReport';
// import StockReportGenerator from './Components/StockReportGenerator';
// import SalesReturnTable from './Components/SalesReturnTable';
// import Receivables from './Components/Receivables';
// import PurchaseBillTable from './Components/PurchaseBillTable';
// import ReturnBillsTable from './Components/ReturnBillTable';
// import BarcodeGenerator from './Components/Barcode';
// import Profile from './Components/Profile';
// import HoldBill from './Components/HoldBill';
// import GoDownStock from './Components/GoDownStock';
// import StoreStock from './Components/StoreStock';
// import StockSummary from './Components/StockSummary';
// import ProductProfitReportGenerator from './Components/ProductProfitReportGenerator';
// import SupplierPaymentEntryReportGenerator from './Components/SupplierPaymentEntryReportGenerator';
// import CustomerWiseReport from './Components/CustomerWiseReportGenerator';
// import CustomersOutstandingReportGenerator from './Components/CustomersOutstandingReportGenerator';
// import PurchaseOutstandingReportGenerator from './Components/PurchaseOutstandingReportGenerator';
// import ExpiryProductReportGenerator from './Components/ExpiryProductReportGenerator';
// import BarcodeListReportGenerator from './Components/BarcodeListReportGenerator';
// import TopSaling from './Components/TopSaling';
// import NonSaling from './Components/NonSaling';
// import BestSaling from './Components/BestSaling';
// import FestivalAI from './Components/FestivalAI';
// import TimelineAI from './Components/TimelineAI';
// import PurchaseSupplierGST from './Components/PurchaseSupplierWiseGST';
// import PurchaseProductWiseGST from './Components/PurchaseProductWiseGST';
// import PurchaseSupplierReturnGST from './Components/PurchaseSupplierReturnGST';
// import PurchaseProductReturnGST from './Components/PurchaseProductReturnGST';
// import SalesCustomerGST from './Components/SalesCustomerGST';
// import SalesProductGST from './Components/SalesProductGST';
// import SalesCustomerReturnGST from './Components/SalesCustomerReturnGST';
// import SalesProductReturnGST from './Components/SalesProductReturnGST';
// import SalesReturnReport from './Components/SalesReturnReport';
// import AddEmployeeRole from './Components/AddEmployeeRole';
// import ManageEmployeeRole from './Components/ManageEmployeeRole';
// import EmployeeRight from './Components/EmployeeRight';
// import EmployeeRights from './Components/EmployeeRights';

// const PlaceholderComponent = ({ title }) => (
//   <div>
//     <h2>{title}</h2>
//     <p>This feature is under development.</p>
//   </div>
// );

// const SUPER_ADMIN_EMAIL = 'saalim@gmail.com';

// function App() {
//   const [allowedMenus, setAllowedMenus] = useState({});
//   const [isSuperAdmin, setIsSuperAdmin] = useState(false);
//   const [isBranch, setIsBranch] = useState(false);

//   useEffect(() => {
//     const unsubscribe = auth.onAuthStateChanged((user) => {
//       if (user) {
//         setIsSuperAdmin(user.email === SUPER_ADMIN_EMAIL);
//         const emailKey = user.email.replace(/\./g, '_');
//         const profileRef = ref(database, `users/${emailKey}/profile`);
//         onValue(profileRef, (snapshot) => {
//           const profileData = snapshot.val();
//           setIsBranch(profileData?.isBranch || false);
//           if (user.email !== SUPER_ADMIN_EMAIL && !profileData?.isBranch) {
//             const rightsRef = ref(database, `employeeRights/${emailKey}`);
//             onValue(rightsRef, (snapshot) => {
//               const data = snapshot.val();
//               setAllowedMenus(data?.allowedMenus || {});
//             });
//           } else {
//             setAllowedMenus({});
//           }
//         }, { onlyOnce: true });
//       } else {
//         setIsSuperAdmin(false);
//         setIsBranch(false);
//         setAllowedMenus({});
//       }
//     });
//     return () => unsubscribe();
//   }, []);

//   useEffect(() => {
//     console.log('🚀 App loaded - ensuring global sync is active...');
//     const syncChecker = setInterval(() => {
//       globalSyncService.ensureSyncActive();
//     }, 30000);
//     return () => clearInterval(syncChecker);
//   }, []);

//   useEffect(() => {
//     const handleVisibilityChange = () => {
//       if (!document.hidden && globalSyncService.currentUser) {
//         console.log('🔄 Tab became visible - ensuring sync is active...');
//         setTimeout(() => {
//           globalSyncService.ensureSyncActive();
//         }, 1000);
//       }
//     };
//     document.addEventListener('visibilitychange', handleVisibilityChange);
//     return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
//   }, []);

//   return (
//     <Router>
//       <div className="App">
//         <Routes>
//           <Route path="/login" element={<LoginPage />} />
//           <Route path="/dashboard" element={<Dashboard />}>
//             <Route path="product" element={<ProductTable />} />
//             <Route path="group-table" element={<GroupTable />} />
//             <Route path="category-table" element={<CategoryTable />} />
//             <Route path="brand-table" element={<BrandTable />} />
//             <Route path="unit-table" element={<UnitTable />} />
//             <Route path="tax" element={<PlaceholderComponent title="Tax" />} />
//             <Route path="gst-tax" element={<AddTax />} />
//             <Route path="payment-modes" element={<Payments />} />
//             <Route path="payables" element={<Payables />} />
//             <Route path="receivables" element={<Receivables />} />
//             <Route path="suppliers" element={<Suppliers />} />
//             <Route path="customers" element={<Customers />} />
//             <Route path="partners" element={<Partners />} />
//             <Route path="purchase-invoice" element={<PurchaseBillTable />} />
//             <Route path="purchase-return" element={<ReturnBillsTable />} />
//             <Route path="barcode-generator" element={<BarcodeGenerator />} />
//             <Route path="salesform" element={<SalesTable />} />
//             <Route path="salesReturn" element={<SalesReturnTable />} />
//             <Route path="purchase-report" element={<PurchaseReportGenerator />} />
//             <Route path="purchase-return-report" element={<PurchaseReturnReportGenerator />} />
//             <Route path="sales-report" element={<SalesReport />} />
//             <Route path="sales-return-report" element={<SalesReturnReport />} />
//             <Route path="product-profit-report" element={<ProductProfitReportGenerator />} />
//             <Route path="accounts-report">
//               <Route path="supplier-payment" element={<SupplierPaymentEntryReportGenerator />} />
//               <Route path="customer-receipt" element={<CustomerWiseReport />} />
//               <Route path="customer-outstanding" element={<CustomersOutstandingReportGenerator />} />
//               <Route path="purchase-outstanding" element={<PurchaseOutstandingReportGenerator />} />
//             </Route>
//             <Route path="product-list-report" element={<BarcodeListReportGenerator />} />
//             <Route path="sales-revenue-report">
//               <Route path="top-selling" element={<TopSaling />} />
//               <Route path="non-selling" element={<NonSaling />} />
//             </Route>
//             <Route path="best-rate-finder" element={<BestSaling />} />
//             <Route path="purchase-annexure-1a" element={<PlaceholderComponent title="Purchase Annexure 1A" />} />
//             <Route path="purchase-annexure-1a/supplierwise" element={<PurchaseSupplierGST />} />
//             <Route path="purchase-annexure-1a/productwise" element={<PurchaseProductWiseGST />} />
//             <Route path="purchase-return-annexure-2a" element={<PlaceholderComponent title="Purchase Return Annexure 2A" />} />
//             <Route path="purchase-return-annexure-2a/supplierwiseReturn" element={<PurchaseSupplierReturnGST />} />
//             <Route path="purchase-return-annexure-2a/productwiseReturn" element={<PurchaseProductReturnGST />} />
//             <Route path="sales-annexure-1a" element={<PlaceholderComponent title="Sales Annexure 1A" />} />
//             <Route path="sales-annexure-1a/customerwise" element={<SalesCustomerGST />} />
//             <Route path="sales-annexure-1a/productwise" element={<SalesProductGST />} />
//             <Route path="sales-return-annexure-2a" element={<PlaceholderComponent title="Sales Return Annexure 2A" />} />
//             <Route path="sales-return-annexure-2a/customerwiseReturn" element={<SalesCustomerReturnGST />} />
//             <Route path="sales-return-annexure-2a/productwiseReturn" element={<SalesProductReturnGST />} />
//             <Route path="location" element={<PlaceholderComponent title="Location" />} />
//             <Route path="settings" element={<PlaceholderComponent title="Settings" />} />
//             <Route path="menus" element={<PlaceholderComponent title="Menus" />} />
//             <Route path="rolesRights">
//               <Route index element={<PlaceholderComponent title="Roles & Rights" />} />
//               <Route path="employeerole" element={<AddEmployeeRole />} />
//               <Route path="manage-employee" element={<ManageEmployeeRole />} />
//               <Route path="employee" element={<EmployeeRights />} />
//               <Route path="employeeright" element={<EmployeeRight />} />
//             </Route>
//             <Route path="general" element={<PlaceholderComponent title="General" />} />
//             <Route path="doc-settings" element={<PlaceholderComponent title="Doc Settings" />} />
//             <Route path="branch-profile" element={<Profile />} />
//             <Route path="stock-report" element={<StockReportGenerator />} />
//             <Route path="stock-report/godown" element={<GoDownStock />} />
//             <Route path="stock-report/store" element={<StoreStock />} />
//             <Route path="stock-report/summary" element={<StockSummary />} />
//             <Route path="expiry-report" element={<ExpiryProductReportGenerator />} />
//             <Route path="ai-reports/festival" element={<FestivalAI />} />
//             <Route path="ai-reports/timeline" element={<TimelineAI />} />
//           </Route>
//           <Route path="/hold-bill" element={<HoldBill />} />
//           <Route path="/" element={<Navigate to="/login" replace />} />
//         </Routes>
//       </div>
//     </Router>
//   );
// }

// export default App;

import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { auth, database, ref, onValue } from './firebase';
import globalSyncService from './Services/GlobalSyncService';
import LoginPage from './Components/LoginPage';
import Dashboard from './Components/Dashboard';
import ProductTable from './Components/ProductTable';
import CategoryTable from './Components/CategoryTable';
import GroupTable from './Components/GroupTable';
import BrandTable from './Components/BrandTable';
import UnitTable from './Components/UnitTable';
import AddTax from './Components/AddTax';
import Payments from './Components/Payments';
import Payables from './Components/Payables';
import Suppliers from './Components/Suppliers';
import Customers from './Components/Customers';
import Partners from './Components/Partners';
import Stocks from './Components/Stocks';
import SalesTable from './Components/SalesTable';
import PurchaseReturnReportGenerator from './Components/PurchaseReturnReport';
import PurchaseReportGenerator from './Components/PurchaseReportGenerator';
import SalesReport from './Components/SalesReport';
import StockReportGenerator from './Components/StockReportGenerator';
import SalesReturnTable from './Components/SalesReturnTable';
import Receivables from './Components/Receivables';
import PurchaseBillTable from './Components/PurchaseBillTable';
import ReturnBillsTable from './Components/ReturnBillTable';
import BarcodeGenerator from './Components/Barcode';
import Profile from './Components/Profile';
import HoldBill from './Components/HoldBill';
import GoDownStock from './Components/GoDownStock';
import StoreStock from './Components/StoreStock';
import StockSummary from './Components/StockSummary';
import ProductProfitReportGenerator from './Components/ProductProfitReportGenerator';
import SupplierPaymentEntryReportGenerator from './Components/SupplierPaymentEntryReportGenerator';
import CustomerWiseReport from './Components/CustomerWiseReportGenerator';
import CustomersOutstandingReportGenerator from './Components/CustomersOutstandingReportGenerator';
import PurchaseOutstandingReportGenerator from './Components/PurchaseOutstandingReportGenerator';
import ExpiryProductReportGenerator from './Components/ExpiryProductReportGenerator';
import BarcodeListReportGenerator from './Components/BarcodeListReportGenerator';
import TopSaling from './Components/TopSaling';
import NonSaling from './Components/NonSaling';
import BestSaling from './Components/BestSaling';
import FestivalAI from './Components/FestivalAI';
import TimelineAI from './Components/TimelineAI';
import PurchaseSupplierGST from './Components/PurchaseSupplierWiseGST';
import PurchaseProductWiseGST from './Components/PurchaseProductWiseGST';
import PurchaseSupplierReturnGST from './Components/PurchaseSupplierReturnGST';
import PurchaseProductReturnGST from './Components/PurchaseProductReturnGST';
import SalesCustomerGST from './Components/SalesCustomerGST';
import SalesProductGST from './Components/SalesProductGST';
import SalesCustomerReturnGST from './Components/SalesCustomerReturnGST';
import SalesProductReturnGST from './Components/SalesProductReturnGST';
import SalesReturnReport from './Components/SalesReturnReport';
import AddEmployeeRole from './Components/AddEmployeeRole';
import ManageEmployeeRole from './Components/ManageEmployeeRole';
import EmployeeRight from './Components/EmployeeRight';
import EmployeeRights from './Components/EmployeeRights';
import DailyExpensePage from './Components/DailyExpensePage';
import DailyExpenseReport from './Components/DailyExpenseReport';
import DesignNo from './Components/DesignNo';
import QRLoginSystem from './Components/QRLoginSystem';
import BottomSellingProductsGenerator from './Components/BottomSellingProductsGenerator';

const PlaceholderComponent = ({ title }) => (
  <div>
    <h2>{title}</h2>
    <p>This feature is under development.</p>
  </div>
);

const SUPER_ADMIN_EMAIL = 'saalim@gmail.com';

function App() {
  const [allowedMenus, setAllowedMenus] = useState({});
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [isBranch, setIsBranch] = useState(false);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setIsSuperAdmin(user.email === SUPER_ADMIN_EMAIL);
        const emailKey = user.email.replace(/\./g, '_');
        const profileRef = ref(database, `users/${emailKey}/profile`);
        onValue(profileRef, (snapshot) => {
          const profileData = snapshot.val();
          setIsBranch(profileData?.isBranch || false);
          if (user.email !== SUPER_ADMIN_EMAIL && !profileData?.isBranch) {
            const rightsRef = ref(database, `employeeRights/${emailKey}`);
            onValue(rightsRef, (snapshot) => {
              const data = snapshot.val();
              setAllowedMenus(data?.allowedMenus || {});
            });
          } else {
            setAllowedMenus({});
          }
        }, { onlyOnce: true });
      } else {
        setIsSuperAdmin(false);
        setIsBranch(false);
        setAllowedMenus({});
      }
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    console.log('🚀 App loaded - ensuring global sync is active...');
    const syncChecker = setInterval(() => {
      globalSyncService.ensureSyncActive();
    }, 30000);
    return () => clearInterval(syncChecker);
  }, []);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden && globalSyncService.currentUser) {
        console.log('🔄 Tab became visible - ensuring sync is active...');
        setTimeout(() => {
          globalSyncService.ensureSyncActive();
        }, 1000);
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, []);

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/dashboard" element={<Dashboard />}>
            <Route path="product" element={<ProductTable />} />
            <Route path="group-table" element={<GroupTable />} />
            <Route path="category-table" element={<CategoryTable />} />
            <Route path="brand-table" element={<BrandTable />} />
            <Route path="unit-table" element={<UnitTable />} />
             <Route path="design-no" element={<DesignNo />} />
              <Route path="daily-expense" element={<DailyExpensePage />} />
            <Route path="tax" element={<PlaceholderComponent title="Tax" />} />
            <Route path="gst-tax" element={<AddTax />} />
            <Route path="payment-modes" element={<Payments />} />
            <Route path="payables" element={<Payables />} />
            <Route path="receivables" element={<Receivables />} />
            <Route path="suppliers" element={<Suppliers />} />
            <Route path="customers" element={<Customers />} />
            <Route path="partners" element={<Partners />} />
            <Route path="stocks" element={<Stocks />} />
            <Route path="purchase-invoice" element={<PurchaseBillTable />} />
            <Route path="purchase-return" element={<ReturnBillsTable />} />
            <Route path="barcode-generator" element={<BarcodeGenerator />} />
            <Route path="salesform" element={<SalesTable />} />
            <Route path="salesReturn" element={<SalesReturnTable />} />
            <Route path="purchase-report" element={<PurchaseReportGenerator />} />
            <Route path="purchase-return-report" element={<PurchaseReturnReportGenerator />} />
            <Route path="sales-report" element={<SalesReport />} />
            <Route path="sales-return-report" element={<SalesReturnReport />} />
            <Route path="stock-report" element={<StockReportGenerator />} />
            <Route path="stock-report/godown" element={<GoDownStock />} />
            <Route path="stock-report/store" element={<StoreStock />} />
            <Route path="stock-report/summary" element={<StockSummary />} />
            <Route path="product-profit-report" element={<ProductProfitReportGenerator />} />
            <Route path="accounts-report">
              <Route index element={<PlaceholderComponent title="Accounts" />} />
              <Route path="supplier-payment" element={<SupplierPaymentEntryReportGenerator />} />
              <Route path="customer-receipt" element={<CustomerWiseReport />} />
              <Route path="customer-outstanding" element={<CustomersOutstandingReportGenerator />} />
              <Route path="purchase-outstanding" element={<PurchaseOutstandingReportGenerator />} />
            </Route>
            <Route path="daily-expense-report" element={<DailyExpenseReport />} />
            <Route path="bacode-list-report" element={<BarcodeListReportGenerator />} />
            <Route path="sales-revenue-report">
              <Route index element={<PlaceholderComponent title="Sales And Revenue Report" />} />
              <Route path="top-selling" element={<TopSaling />} />
              <Route path="non-selling" element={<NonSaling />} />
                            <Route path="Bottom-selling" element={<BottomSellingProductsGenerator />} />
            </Route>
            <Route path="ai-reports">
              <Route index element={<PlaceholderComponent title="AI" />} />
              <Route path="festival" element={<FestivalAI />} />
              <Route path="timeline" element={<TimelineAI />} />
            </Route>
            <Route path="best-rate-finder" element={<BestSaling />} />
            <Route path="purchase-annexure-1a">
              <Route index element={<PlaceholderComponent title="Purchase Annexure 1A" />} />
              <Route path="supplierwise" element={<PurchaseSupplierGST />} />
              <Route path="productwise" element={<PurchaseProductWiseGST />} />
            </Route>
            <Route path="purchase-return-annexure-2a">
              <Route index element={<PlaceholderComponent title="Purchase Return Annexure 2A" />} />
              <Route path="supplierwiseReturn" element={<PurchaseSupplierReturnGST />} />
              <Route path="productwiseReturn" element={<PurchaseProductReturnGST />} />
            </Route>
            <Route path="sales-annexure-1a">
              <Route index element={<PlaceholderComponent title="Sales Annexure_1A" />} />
              <Route path="customerwise" element={<SalesCustomerGST />} />
              <Route path="productwise" element={<SalesProductGST />} />
            </Route>
            <Route path="sales-return-annexure-2a">
              <Route index element={<PlaceholderComponent title="Sales Return Annexure_2A" />} />
              <Route path="customerwiseReturn" element={<SalesCustomerReturnGST />} />
              <Route path="productwiseReturn" element={<SalesProductReturnGST />} />
            </Route>
            <Route path="rolesRights">
              <Route index element={<PlaceholderComponent title="Roles & Rights" />} />
              <Route path="employeerole" element={<AddEmployeeRole />} />
              <Route path="manage-employee" element={<ManageEmployeeRole />} />
              <Route path="employeeright" element={<EmployeeRight />} />
              <Route path="qrloginsystem" element={<QRLoginSystem />} />
            </Route>
            <Route path="branch-profile" element={<Profile />} />
          </Route>
          <Route path="/hold-bill" element={<HoldBill />} />
          <Route path="/" element={<Navigate to="/login" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;